import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requirePermission } from '@/app/guards';
import { QueuePage } from '@/features/operations';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/operations')({
  validateSearch: z.object({ queue: zSearchText(), item: zSearchText(), q: zSearchText(), filter: zSearchText() }),
  staticData: { crumb: 'nav.operations' },
  beforeLoad: ({ context }) =>
    requirePermission(context.queryClient, 'operations.update', 'Operations'),
  component: function Operations() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <QueuePage
        scope="operations"
        queue={search.queue}
        item={search.item}
        q={search.q}
        filter={search.filter}
        onChange={(patch, replace) =>
          void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: replace ?? false })
        }
      />
    );
  },
});
